export const UPDATE_GEOLOCATION_REQUEST_HIDDEN_DATE_TS =
  'UPDATE_GEOLOCATION_REQUEST_HIDDEN_DATE_TS' as const

export const updateGeolocationRequestHiddenDateTsAction = (
  geolocationRequestHiddenDateTs: number = Date.now()
) => ({
  type: UPDATE_GEOLOCATION_REQUEST_HIDDEN_DATE_TS,
  geolocationRequestHiddenDateTs,
})
